
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M484.8 212.8h64v664h-64z",
        "fill": "#ffffff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M523.2 928c-9.6 0-19.2-4.8-25.6-12.8-25.6-35.2-81.6-59.2-134.4-59.2H48c-17.6 0-32-14.4-32-32V139.2c0-11.2 4.8-20.8 11.2-28.8C41.6 96 62.4 96 76.8 96h276.8c76.8 0 155.2 41.6 190.4 102.4 9.6 14.4 4.8 35.2-11.2 43.2-14.4 9.6-35.2 4.8-43.2-11.2-24-40-83.2-72-136-72H80v632h283.2c72 0 147.2 33.6 185.6 83.2 11.2 14.4 8 33.6-6.4 44.8-6.4 6.4-12.8 9.6-19.2 9.6z",
        "fill": "#ffffff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M523.2 928c-6.4 0-12.8-1.6-19.2-6.4-14.4-11.2-17.6-30.4-6.4-44.8 38.4-49.6 112-83.2 185.6-83.2H944V160H691.2c-56 0-123.2 32-147.2 72-9.6 14.4-28.8 20.8-43.2 11.2-14.4-9.6-20.8-28.8-11.2-43.2C529.6 132.8 624 96 691.2 96h276.8c6.4 0 19.2 0 28.8 9.6 11.2 11.2 11.2 24 11.2 30.4v688c0 17.6-14.4 32-32 32H681.6c-52.8 0-107.2 24-134.4 59.2-4.8 8-14.4 12.8-24 12.8z",
        "fill": "#ffffff"
      }
    }
  ]
})
    }
  